"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fcoin = require("fcoin");
/* Create a Flo p2p Peer */


var Peer = /*#__PURE__*/function () {
  /**
   * Initialize the Peer
   * @param  {Object} settings
   * @param  {Object} settings.ip - The IP address of the Flo Peer to connect to
   * @param  {Object} [settings.agent="js-oip fcoin Peer"] - The "name" to display to nodes you connect to.
   * @return {Peer}
   */
  function Peer(settings) {
    _classCallCheck(this, Peer);

    // Store our internally settings for later use
    this.settings = settings; // Rename the mainnet network to be what fcoin expects

    if (this.settings.network === 'mainnet' || this.settings.network === 'livenet') {
      this.settings.network = 'main';
    } // Set the initial connection status


    this.connected = false; // Initialize the transaction map to store { 'txid': 'hex' } the txid related to the hex

    this.txMap = {}; // Initialize a logging limiter variable

    this.singleLog = 0;
  }
  /**
   * Open a p2p connection to the Peer
   * @return {Boolean} Returns the connection status
   */


  _createClass(Peer, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var log, address;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log = (0, _fcoin.logger)({
                  level: 'spam'
                }); // Create the Fcoin Peer

                this.peer = _fcoin.peer.fromOptions({
                  logger: log,
                  network: this.settings.network,
                  agent: this.settings.agent,
                  hasWitness: function hasWitness() {
                    return false;
                  }
                }); // Create a netaddress from our passed in IP address:port

                address = _fcoin.netaddress.fromHostname(this.settings.ip); // Fire off the initial connection attempt

                this.peer.connect(address); // When we recieve packets from peers, process them using the onPacket function

                this.peer.on('packet', this.onPacket.bind(this)); // Handle/log errors

                this.peer.on('error', function (e) {
                  console.log('Peer Error: ' + e);
                });
                _context.prev = 6;
                _context.next = 9;
                return this.peer.open();

              case 9:
                // Set connected to true once we have connected
                this.connected = true;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                // Handle connection error and set connected explicitly to false
                this.connected = false;

              case 15:
                return _context.abrupt("return", this.connected);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
    /**
     * Announce the availability of a Transaction to the Peer
     * @param  {String} hex - The hex string of the transaction
     */

  }, {
    key: "announceTX",
    value: function announceTX(hex) {
      // First, check if we are connected before attempting to broadcast out
      if (this.connected) {
        try {
          // Create an `fcoin` transaction from our tx hex
          var mytx = (0, _fcoin.tx)().fromRaw(Buffer.from(hex, 'hex')); // Store the hash of the transaction in our txMap

          this.txMap[mytx.hash('hex')] = hex; // Announce the Transaction to the peer

          this.peer.announceTX(mytx);
        } catch (e) {
          // Throw an error if one happened
          console.error('Announce TX Error: ' + e);
        }
      }
    }
    /**
     * Handle incoming p2p packets
     * @param  {Packet} packet - The packet that is incoming
     */

  }, {
    key: "onPacket",
    value: function onPacket(packet) {
      // Check which packet type is incoming
      switch (packet.type) {
        // If the packet is `GETDATA` that means they are requesting us to send them tne transaction
        case _fcoin.packets.types.GETDATA:
          // Send the transaction to the peer
          this.handleGetData(packet);
          break;
      }
    }
    /**
     * Handle (respond to) a p2p getdata request
     * @param  {GetDataPacket} getDataPacket - The packet to respond to with data
     */

  }, {
    key: "handleGetData",
    value: function handleGetData(getDataPacket) {
      // Track the total number of transactions relayed
      var txsRelayed = 0; // Track the last txid hash that we sent

      var lastHash; // If the peer is requesting more than one transaction, or if they have not met the singlelog maximum, then log the request

      if (getDataPacket.items.length > 1 || this.singleLog < 5) {
        console.log("[RPC Wallet] Peer ".concat(this.settings.ip, " requested ").concat(getDataPacket.items.length, " items..."));
      } // Loop through each requested item in the getData packet


      var _iterator = _createForOfIteratorHelper(getDataPacket.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          // We only care about responding if they are requesting a transction
          var regTX = item.type === _fcoin.invitem.types.TX;
          var segTX = item.type === _fcoin.invitem.types.WITNESS_TX; // If we are a regular tx, or a segwit tx, then continue

          if (regTX || segTX) {
            // Check to see if we have this transction in our txMap, and if not, skip it (ignore transactions that are not our own)
            if (!this.txMap[item.hash]) {
              return;
            } // Create an `fcoin` tx from the cached tx hex


            var mytx = (0, _fcoin.tx)().fromRaw(Buffer.from(this.txMap[item.hash], 'hex')); // Include the transaction in a TXPacket to be sent to the Peer

            var txPacket = _fcoin.packets.TXPacket(mytx, segTX); // Send out the TXPacket to the Peer


            this.peer.send(txPacket); // Increase our count of transactions relayed

            txsRelayed++; // Store the previous hash (for logging purposes)

            lastHash = mytx.rhash();
          }
        } // If we have responded to at least one getdata item, then log our response

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (txsRelayed > 0) {
        // If we have logged a single tx being relayed more than 5 times, then just skip logging (to prevent spam)
        if (txsRelayed === 1 && this.singleLog > 5) {
          return;
        } // If we only relayed a single transaction, then increase the "singleLog" counter


        if (txsRelayed === 1) {
          this.singleLog++;
        } // Log information about the sent transactions


        console.log("[RPC Wallet] Relayed ".concat(txsRelayed, " requested transactions to ").concat(this.settings.ip, " (last txid ").concat(lastHash, ")"));
      }
    }
  }]);

  return Peer;
}();

var _default = Peer;
exports.default = _default;